// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-505e7037]:root{--sticky-header-height:8.75rem;--environment-footer-height:2 * 1.25rem}.toilet-icon[data-v-505e7037]{width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
